import Vue from 'vue'
import Vuex from 'vuex'
import localforage from 'localforage'
import api from '../services/api'
import { weekCart } from './weekCart.module'
import { productsManagement } from './productsManagement.module'
import { periods } from './periods.module'
import { customer } from './customer.module'
import { notifications } from './notifications.module'
import { packages } from './packages.module'
import { app } from './app.module'
import { discouts } from './discouts.module'
import { modal } from './modal.module'
import { terms } from './terms.module'
import { payments } from './payments.module'
import { order } from './order.module'
import { deliveryHours } from './deliveryHours.module'
import { settings } from './settings.module'
import { packageCategories } from './packageCategories.module'
import { offer } from './offer.module'
import { users } from './client/users.module'
import { deliveries } from './client/deliveries.module'
import { companies } from './client/companies.module'
import { offers } from './client/offers.module'
import { invoices } from './client/invoices.module'
import { clientPayments } from './client/clientPayments.module'
import { complaints } from './client/complaints.module'
import { drag } from './drag.module'
import { infoSources } from './infoSources.module'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        weekCart,
        productsManagement,
        periods,
        customer,
        notifications,
        packages,
        app,
        discouts,
        modal,
        terms,
        payments,
        order,
        deliveryHours,
        settings,
        packageCategories,
        offer,
        users,
        deliveries,
        companies,
        offers,
        invoices,
        clientPayments,
        complaints,
        drag,
        infoSources
    }
})

// add extensions support
store.$api = api
store.$storage = localforage
store.$vue = Vue

export default store
